import React from "react";
import Head from 'next/head';

type HeadTagsProps = {
  title?: string
  description?: string
  path?: string
  schema?: any
  noIndex?: boolean
}

const HeadTags = ({ title, description, path, schema = null, noIndex = false }: HeadTagsProps) => {
  const defaultTitle = "❤ We Celebrate! | El cotillón más lindo y original, listo para usar";
  const defaultDescription = "Festejá tus eventos y fiestas con nuestros diseños innovadores realizados artesanalmente. Tenemos muchas categorías para decorarle a los que más querés. Amor, arco iris, calaveras, mexican party, circo, kermesse, conejo, dinosaurios, gatitos, granja, Gravity Falls, Halloween, Kitty, Fortnite, llama, LOL, debajo del mar, marinero, Mario Bross, Mickey, Muppets, Peppa Pig, perritos, Ponys, princesas, selva, sirena, despedida de soltera, super héroes, Trolls, tropical, unicornos, vaquita de San Antonio y mucho más!";

  // El texto de descripción viene de campos de Strapi que a veces traen saltos
  // de línea sueltos (tipeados o pegados por el editor de contenido); sin
  // normalizar, ese salto de línea queda crudo dentro del atributo content="".
  const cleanDescription = (description || defaultDescription).replace(/\s*\n+\s*/g, ' ').trim();

  return (
    <>
      <Head>
        <title>{title ? `${title} | ${defaultTitle}` : defaultTitle}</title>
        <meta charSet="UTF-8" />
        <meta name="Content-Language" content="es-ar" />
        <meta name="Distribution" content="global" />
        <meta name="Revisit" content="1 days" />
        <meta name="Robots" content={noIndex ? "noindex, nofollow" : "all"} />
        <meta name="Googlebot" content={noIndex ? "noindex, nofollow" : "all"} />
        <meta name="Keywords" content={cleanDescription} />
        <meta name="description" content={cleanDescription} />
        <meta name="author" content="spiral-studio.com" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="initial-scale=1, maximum-scale=5, user-scalable=yes, width=device-width" />
        <meta name="msapplication-TileColor" content="#ffe1dd" />
        <meta name="msapplication-TileImage" content={`${process.env.NEXT_PUBLIC_URL_FRONTEND}/img/favicon/ms-icon-144x144.png`} />
        <meta name="theme-color" content="#ffe1dd" />
        { /* Apple Touch Icons */}
        { /* Other favicon links omitted for brevity */}
        <link rel="canonical" href={`${process.env.NEXT_PUBLIC_URL_FRONTEND}${path || '/'}`} />
        <meta name="twitter:card" content="summary" />
        <meta property="og:title" content="We Celebrate!" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${process.env.NEXT_PUBLIC_URL_FRONTEND}${path || '/'}`} />
        <meta property="og:image" content={`${process.env.NEXT_PUBLIC_URL_FRONTEND}/img/meta-1400x627.jpg`} />
        <meta property="og:image:width" content="1400" />
        <meta property="og:image:height" content="627" />
        <meta property="og:description" content="El cotillón más lindo y original, listo para usar" />
        <meta name="google-site-verification" content="tJ5yurxU8cac_pF2PHMmyEDraUJ5BoZJUMBsK0CTo3M" />
        <meta name="Distribution" content="global" />
        <meta name="Revisit" content="1 days" />
        { /* <meta name="facebook-domain-verification" content="a9rlio0fjh8co79wqxxvys09tt5oj1" /> */}
        {schema &&
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(schema),
            }}
          />
        }
      </Head>
    </>
  );
};

export default HeadTags;
